<span class="glyphicon glyphicon-heart"
      [class.highlighted]="isLiked"
      (click)="onClick()"></span>

<span>{{likesCount}}</span>
